
import { Component, Prop, State, Vue } from "nuxt-property-decorator";
import type { PropType } from "vue";
import { Metadata, Navigation, Settings } from "~/types/initialData";
import { constructTYPO3Url } from "~/util/typo3Urls";
import Link from "~/components/ui/toc/links/Link";
import SiteMapTreeItem from "~/components/ui/sitemap/SiteMapTreeItem.vue";
import TooltipButton from "@/components/ui/TooltipButton.vue";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from "html-to-pdfmake";
import { pushEvent } from '@/util/grafana-faro';
import SiteMapRaw from "~/components/ui/sitemap/SiteMapRaw.vue";
import { prettyFormatTimestamp } from "@/util/timestampFormat";

@Component({
  components: {
    SiteMapTreeItem,
    TooltipButton,
    SiteMapRaw
  }
})

export default class SiteMap extends Vue {

  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.id)
  pageId: number;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.settings)
  settings: Settings;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.metadata)
  metadata: Metadata;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.navigation)
  navigation!: Navigation;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.navigation?.[0] ?? [])
  navMain;

  @Prop({
    type: Object as PropType<Link>,
    required: false
  })
  link: Link;

  @Prop({
    type: Boolean,
    required: false
  })
  directLink: boolean;

  get exportedDateTime(): string {
    return prettyFormatTimestamp(
      new Date(),
      this.$i18n.localeProperties.code
    );
  }

  get hasChildren() {
    return this.link.children && this.link.children.length > 0;
  }

  get linkIsOnlyForTeachers(): boolean {
    return [2, 21].includes(Number(this.link.fe_group));
  }

  get isComponentPage(): boolean {
    return this.settings.tocPagePid === this.pageId || this.directLink;
  }

  get tocPageUrl(): string {
    if (this.settings.tocPagePid && this.settings.tocPagePid > 0) {
      return constructTYPO3Url(this.settings.tocPagePid.toString());
    }
    return "";
  }

  mounted() {
    this.$nextTick(() => {
      if (this.isComponentPage) this.grafano();
    });
  }

  grafano(): void {
    pushEvent('SiteMap', {
      type: 'Button',
      component: 'SiteMap'
    });
  }

  downloadSitemap(): void {
    /* User clicked download SiteMap button */
    pushEvent('SiteMap', {
      value: 'DownloadSitemap',
      type: 'Button',
      component: 'SiteMap'
    });

    const fontName = "NotoSans";
    const fonts = {
      [fontName]: {
        normal: `${window.location.origin}/pdf-fonts/NotoSans-Regular.ttf`,
        bold: `${window.location.origin}/pdf-fonts/NotoSans-Bold.ttf`,
        italics: `${window.location.origin}/pdf-fonts/NotoSans-Italic.ttf`,
        bolditalics: `${window.location.origin}/pdf-fonts/NotoSans-BoldItalic.ttf`
      }
    };
    const content: any = [];
    const footerContent: any = [];
    content.push(htmlToPdfmake(document.getElementById("sitemap-raw").innerHTML));
    footerContent.push({
      columns: [
        {
          text: `${this.metadata.title}`,
          alignment: "left",
          color: "#767676",
          marginLeft: 40,
          marginTop: 20,
          marginBottom: 40,
          fontSize: 10
        },
        {
          text: `ISBN: ${this.metadata.isbn13}`,
          alignment: "right",
          color: "#767676",
          marginRight: 40,
          marginTop: 20,
          marginBottom: 40,
          fontSize: 10
        }
      ]
    });
    const docDef = {
      content: content,
      info: {
        author: this.metadata.author,
        title: this.metadata.title,
        subject: this.$t("labels.sitemap.plugin.header")
      },
      styles: {
        header: {
          font: fontName,
          fontSize: 20,
          bold: true,
          color: "#000000",
          margin: 0,
          padding: 0
        },
        subheader: {
          font: fontName,
          fontSize: 12,
          color: "#767676",
          margin: 0,
          marginTop: -12,
          padding: 0
        },
        pbooknumber: {
          color: "#767676",
          fontSize: 12,
          font: fontName
        },
        spacer: {
          paddingRight: 60,
          paddingLeft: 60,
          marginRight: 60,
          marginLeft: 60
        }
      },
      defaultStyle: {
        font: fontName
      },
      footer: footerContent,
      pageMargins: 60
    };
    const downloadName: string = this.metadata.title.replace(/\s/g, "") + "-" + Math.floor(Date.now() / 1000) + ".pdf".trim();
    pdfMake
      .createPdf(docDef, null, fonts)
      .download(downloadName);
  }

}
